import React from 'react';

import Header from '../Header';
import Sidebar from '../Sidebar';
import Footer from '../Footer';

import { LayoutContainer, ContentArea, MainContent } from './styles';

export default function MainLayout({ children, showSidebar = true }) {
  return (
    <LayoutContainer>
      <Header />
      <ContentArea>
        {showSidebar && <Sidebar />}
        <MainContent>{children}</MainContent>
      </ContentArea>
      <Footer />
    </LayoutContainer>
  );
}
